<!-- Some component.vue -->
<template>
    <vue-simple-suggest
            v-bind="$attrs"
            ref="vss"
            v-model="chosen"
            :debounce="200"
            mode="input"
            :removeList="clearLists"
            :max-suggestions="maxSuggestions"
            :list="getSuggestionList"
            :min-length="minLength"
            :filter-by-query="false"
            :placeholder="placeholder"
            @suggestion-click="onSelect"
            @select="onSelect"
            @input="onInput"
            @focus="onFocusVueSuggest"
            :aria-label="placeholder"
    ></vue-simple-suggest>
</template>

<script>
    import axios from 'axios';
    import VueSimpleSuggest from 'vue-simple-suggest/lib'

    // ORIGINAL vue-simple-suggest CSS
    import 'vue-simple-suggest/dist/styles.css';

    export default {
        props: {
            prepopulateChosen: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: null
            },
            minLength: {
                type: Number,
                default: 2
            },
            maxSuggestions: {
                type: Number,
                default: 10
            },
            apiCall: {
                type: String,
                default: ''
            },
            withPublishedJobs: {
                type: Boolean,
                default: true
            },
            suggestOnlyCompany: {
                type: Boolean,
                default: false
            },
            usePostalCode: {
              type: Boolean,
              default: false,
            }
        },
        watch: {
            prepopulateChosen: {
                handler: function(val) {
                    this.chosen = val;
                },
                immediate: true
            },
            chosen(val) {
              this.handleUsePostalCode(val);
            },
        },
        components: {
            VueSimpleSuggest
        },
        data() {
            return {
                chosen: '',
                clearLists: false,
                inputIDEl: null
            }
        },
        methods: {
          handleUsePostalCode(val) {
            if (this.usePostalCode === true) {
              if ((val[0] || '').match(/[0-9]/)) {
                this.$nextTick(() => {
                  this.chosen = val.replace(/[^0-9]/, '').slice(0, 5);
                })
              } else {
                this.$nextTick(() => {
                  this.chosen = val.replace(/[0-9]/, '');
                })
              }
            }
          },
            onFocusVueSuggest() {
                this.$emit('onFocusVueSuggest');
            },
            getSuggestionList(val) {
                return axios.post(this.apiCall, { search: val, withPublishedJobs: this.withPublishedJobs, suggestOnlyCompany: this.suggestOnlyCompany })
                        .then(response => {
                            return JSON.parse(JSON.stringify(response.data));
                        });
            },
            onSelect(val) {
                this.clearLists = true;
                this.$emit('onSelect', val);
            },
            onInput(ev) {
                if (this.clearLists && ev.length === 0) {
                    this.clearLists = false;
                }
                this.$emit('onInput', ev);
            },
            handleKeyup(ev) {
                if (ev.keyCode === 13) {
                    this.$emit('onSubmit');
                }
            }
        },

        mounted() {
            if (this.$attrs.id) {
                this.inputIDEl = document.getElementById(this.$attrs.id);
                if (this.inputIDEl) {
                    this.inputIDEl.addEventListener('keyup', this.handleKeyup)
                }
            }else {
                // a reminder for dev team
                console.error('Need to set ID attribute, to handle the input properly.');
            }
        },

        beforeDestroy() {
            if (this.inputIDEl) {
                this.inputIDEl.removeEventListener("keyup", this.handleKeyup)
            }
        }
    }
</script>

<style lang="scss">
    // VUEXY vue-simple-suggest CSS
    @import "../../sass/vuexy/extraComponents/autocomplete.scss";

    .vue-simple-suggest > ul.suggestions >li.suggest-item {
      white-space: pre-wrap;
      white-space: -moz-pre-wrap;
      white-space: -pre-wrap;
      white-space: -o-pre-wrap;
      word-wrap: break-word;
      word-break: break-all;
    }
</style>
